'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayName = exports.identifier = exports.options = exports.Raw = undefined;

var _reactCssThemr = require('react-css-themr');

var _SmartFormTextarea = require('lemon-ui/lib/collections/SmartForm/SmartFormTextarea');

var _factory = require('./factory');

var _factory2 = _interopRequireDefault(_factory);

var _normal = require('./_normal.scss');

var _normal2 = _interopRequireDefault(_normal);

var _identifiers = require('../identifiers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var factoryParams = {
  identifier: _identifiers.TEXTAREA,
  UITextarea: _SmartFormTextarea.SmartTextarea
};
var Textarea = (0, _factory2['default'])(factoryParams);
/** @component */

var themed = (0, _reactCssThemr.themr)(_identifiers.TEXTAREA, _normal2['default'])(Textarea);
exports.Raw = Textarea;
exports.options = _factory.options;
exports.identifier = _identifiers.TEXTAREA;
exports.displayName = _identifiers.TEXTAREA;
exports['default'] = themed;